export interface FreshnessSurface {
  window: Pick<EventTarget, "addEventListener" | "removeEventListener">;
  document: Pick<EventTarget, "addEventListener" | "removeEventListener"> & {
    visibilityState: string;
  };
}
export function subscribeFreshness(
  surface: FreshnessSurface,
  refresh: () => void,
) {
  const visible = () => {
    if (surface.document.visibilityState === "visible") refresh();
  };
  surface.window.addEventListener("focus", visible);
  surface.window.addEventListener("juyici:identity", visible);
  surface.document.addEventListener("visibilitychange", visible);
  return () => {
    surface.window.removeEventListener("focus", visible);
    surface.window.removeEventListener("juyici:identity", visible);
    surface.document.removeEventListener("visibilitychange", visible);
  };
}
